export const courses = [
  {
    id: 1,
    slug: "ai-ml-fundamentals",
    icon: "ri-brain-line",
    category: "Artificial Intelligence",
    categoryColor: "from-violet-500 to-indigo-500",
    categoryBg: "bg-violet-50",
    categoryText: "text-violet-600",
    title: "AI & Machine Learning Fundamentals",
    tagline: "Go from zero to AI-ready in 8 weeks",
    duration: "8 Weeks",
    level: "Beginner",
    price: 499,
    originalPrice: 699,
    students: 1240,
    rating: 4.9,
    reviews: 312,
    nextStart: "May 5, 2026",
    format: "Live Online",
    image: "https://readdy.ai/api/search-image?query=artificial%20intelligence%20machine%20learning%20neural%20network%20abstract%20visualization%20glowing%20nodes%20dark%20background%20futuristic%20technology%20concept%20professional%20wide&width=800&height=480&seq=ac1&orientation=landscape",
    description: "Master the foundations of AI and machine learning. Learn Python, data preprocessing, supervised and unsupervised learning, neural networks, and how to deploy real-world ML models.",
    outcomes: [
      "Build and train machine learning models from scratch",
      "Understand neural networks and deep learning concepts",
      "Work with real datasets using Python & scikit-learn",
      "Deploy ML models to production environments",
      "Apply AI to solve real business problems",
    ],
    curriculum: [
      { week: "Week 1–2", topic: "Python for Data Science & ML Foundations" },
      { week: "Week 3–4", topic: "Supervised Learning: Regression & Classification" },
      { week: "Week 5", topic: "Unsupervised Learning & Clustering" },
      { week: "Week 6", topic: "Neural Networks & Deep Learning Intro" },
      { week: "Week 7", topic: "Model Evaluation, Tuning & Optimization" },
      { week: "Week 8", topic: "Capstone Project & Model Deployment" },
    ],
    instructor: { name: "Chen Wei", role: "AI Research Lead, PhD MIT", avatar: "CW", color: "from-violet-400 to-indigo-500" },
    includes: ["16 live sessions", "Recorded replays", "Hands-on labs", "Industry certificate", "Slack community", "Career support"],
  },
  {
    id: 2,
    slug: "cybersecurity-bootcamp",
    icon: "ri-shield-keyhole-line",
    category: "Cybersecurity",
    categoryColor: "from-rose-500 to-pink-500",
    categoryBg: "bg-rose-50",
    categoryText: "text-rose-600",
    title: "Advanced Cybersecurity Bootcamp",
    tagline: "Become a certified security professional in 12 weeks",
    duration: "12 Weeks",
    level: "Advanced",
    price: 799,
    originalPrice: 1099,
    students: 876,
    rating: 4.8,
    reviews: 198,
    nextStart: "May 12, 2026",
    format: "Live Online",
    image: "https://readdy.ai/api/search-image?query=cybersecurity%20operations%20center%20dark%20screens%20security%20monitoring%20hacker%20defense%20professional%20dramatic%20lighting%20technology%20atmosphere%20wide&width=800&height=480&seq=ac2&orientation=landscape",
    description: "An intensive, hands-on bootcamp covering penetration testing, zero-trust architecture, cloud security, SIEM, and compliance frameworks. Designed for IT professionals ready to specialize in security.",
    outcomes: [
      "Perform professional penetration testing and vulnerability assessments",
      "Design and implement zero-trust security architectures",
      "Secure cloud environments on AWS, Azure, and GCP",
      "Configure and manage SIEM tools for threat detection",
      "Achieve compliance with SOC2, HIPAA, and PCI-DSS",
    ],
    curriculum: [
      { week: "Week 1–2", topic: "Security Fundamentals & Threat Landscape" },
      { week: "Week 3–4", topic: "Network Security & Penetration Testing" },
      { week: "Week 5–6", topic: "Cloud Security (AWS/Azure/GCP)" },
      { week: "Week 7–8", topic: "Zero-Trust Architecture & IAM" },
      { week: "Week 9–10", topic: "SIEM, Threat Hunting & Incident Response" },
      { week: "Week 11–12", topic: "Compliance Frameworks & Capstone" },
    ],
    instructor: { name: "Priya Nair", role: "Head of Cybersecurity, CISSP", avatar: "PN", color: "from-rose-400 to-pink-500" },
    includes: ["24 live sessions", "Recorded replays", "CTF challenges", "Industry certificate", "Slack community", "Job placement support"],
  },
  {
    id: 3,
    slug: "cloud-architecture",
    icon: "ri-cloud-line",
    category: "Cloud Computing",
    categoryColor: "from-sky-500 to-cyan-500",
    categoryBg: "bg-sky-50",
    categoryText: "text-sky-600",
    title: "Cloud Architecture Masterclass",
    tagline: "Design enterprise-grade cloud systems",
    duration: "6 Weeks",
    level: "Intermediate",
    price: 599,
    originalPrice: 799,
    students: 654,
    rating: 4.9,
    reviews: 145,
    nextStart: "May 19, 2026",
    format: "Live Online",
    image: "https://readdy.ai/api/search-image?query=cloud%20computing%20architecture%20abstract%20data%20center%20servers%20glowing%20connections%20modern%20technology%20professional%20clean%20minimal%20light%20background%20wide&width=800&height=480&seq=ac3&orientation=landscape",
    description: "Learn to design, deploy, and manage scalable cloud infrastructure on AWS, Azure, and GCP. Covers microservices, DevOps pipelines, cost optimization, and high-availability architecture patterns.",
    outcomes: [
      "Architect scalable, fault-tolerant cloud systems",
      "Build CI/CD pipelines with modern DevOps tools",
      "Optimize cloud costs and resource utilization",
      "Design microservices and containerized applications",
      "Prepare for AWS Solutions Architect certification",
    ],
    curriculum: [
      { week: "Week 1", topic: "Cloud Fundamentals & Provider Comparison" },
      { week: "Week 2", topic: "Compute, Storage & Networking on AWS/Azure" },
      { week: "Week 3", topic: "Containers, Kubernetes & Microservices" },
      { week: "Week 4", topic: "CI/CD Pipelines & DevOps Automation" },
      { week: "Week 5", topic: "Cost Optimization & High Availability" },
      { week: "Week 6", topic: "Capstone: Design a Production Architecture" },
    ],
    instructor: { name: "Amara Johnson", role: "Cloud Architect, AWS & Azure Certified", avatar: "AJ", color: "from-sky-400 to-cyan-500" },
    includes: ["12 live sessions", "Recorded replays", "AWS sandbox access", "Industry certificate", "Slack community", "Career support"],
  },
  {
    id: 4,
    slug: "data-analytics-python",
    icon: "ri-bar-chart-2-line",
    category: "Data Analytics",
    categoryColor: "from-amber-500 to-yellow-500",
    categoryBg: "bg-amber-50",
    categoryText: "text-amber-600",
    title: "Data Analytics with Python & SQL",
    tagline: "Turn raw data into business insights",
    duration: "6 Weeks",
    level: "Beginner",
    price: 449,
    originalPrice: 599,
    students: 980,
    rating: 4.8,
    reviews: 267,
    nextStart: "May 26, 2026",
    format: "Live Online",
    image: "https://readdy.ai/api/search-image?query=data%20analytics%20python%20SQL%20dashboard%20charts%20graphs%20business%20intelligence%20modern%20office%20professional%20clean%20minimal%20light%20neutral%20background%20wide&width=800&height=480&seq=ac4&orientation=landscape",
    description: "A practical, project-based course covering Python, SQL, Pandas, data visualization with Matplotlib and Tableau, and building BI dashboards that drive real business decisions.",
    outcomes: [
      "Write complex SQL queries for data extraction and analysis",
      "Use Python & Pandas for data cleaning and transformation",
      "Build compelling visualizations with Matplotlib & Seaborn",
      "Create interactive Tableau dashboards",
      "Present data-driven insights to stakeholders",
    ],
    curriculum: [
      { week: "Week 1", topic: "SQL Foundations & Advanced Queries" },
      { week: "Week 2", topic: "Python for Data Analysis (Pandas, NumPy)" },
      { week: "Week 3", topic: "Data Cleaning & Preprocessing" },
      { week: "Week 4", topic: "Data Visualization (Matplotlib, Seaborn)" },
      { week: "Week 5", topic: "Tableau & BI Dashboard Design" },
      { week: "Week 6", topic: "Capstone: End-to-End Analytics Project" },
    ],
    instructor: { name: "Linda Torres", role: "Director of Analytics, 10+ yrs exp", avatar: "LT", color: "from-amber-400 to-yellow-500" },
    includes: ["12 live sessions", "Recorded replays", "Real datasets", "Industry certificate", "Slack community", "Portfolio project"],
  },
  {
    id: 5,
    slug: "digital-marketing-pro",
    icon: "ri-megaphone-line",
    category: "Digital Marketing",
    categoryColor: "from-orange-500 to-red-500",
    categoryBg: "bg-orange-50",
    categoryText: "text-orange-600",
    title: "Digital Marketing Pro Certification",
    tagline: "Master SEO, PPC, and social media growth",
    duration: "8 Weeks",
    level: "Beginner",
    price: 399,
    originalPrice: 549,
    students: 1560,
    rating: 4.7,
    reviews: 421,
    nextStart: "May 5, 2026",
    format: "Live Online",
    image: "https://readdy.ai/api/search-image?query=digital%20marketing%20social%20media%20strategy%20analytics%20modern%20workspace%20laptop%20charts%20professional%20clean%20minimal%20warm%20neutral%20tones%20wide&width=800&height=480&seq=ac5&orientation=landscape",
    description: "A comprehensive digital marketing certification covering SEO, Google Ads, social media strategy, email marketing, content creation, and conversion rate optimization.",
    outcomes: [
      "Rank websites on page 1 of Google with proven SEO techniques",
      "Run profitable Google Ads and Meta Ads campaigns",
      "Build and grow engaged social media audiences",
      "Design high-converting email marketing sequences",
      "Measure and optimize campaigns with Google Analytics 4",
    ],
    curriculum: [
      { week: "Week 1–2", topic: "SEO Fundamentals & Technical Optimization" },
      { week: "Week 3", topic: "Google Ads & PPC Campaign Management" },
      { week: "Week 4", topic: "Social Media Strategy & Content Creation" },
      { week: "Week 5", topic: "Email Marketing & Automation" },
      { week: "Week 6", topic: "Analytics, Tracking & Reporting (GA4)" },
      { week: "Week 7–8", topic: "Capstone: Full Campaign Launch" },
    ],
    instructor: { name: "James Adeyemi", role: "VP of Digital Marketing, 200+ brands", avatar: "JA", color: "from-orange-400 to-red-500" },
    includes: ["16 live sessions", "Recorded replays", "Ad account access", "Industry certificate", "Slack community", "Agency toolkit"],
  },
  {
    id: 6,
    slug: "fullstack-app-dev",
    icon: "ri-smartphone-line",
    category: "App Development",
    categoryColor: "from-emerald-500 to-teal-500",
    categoryBg: "bg-emerald-50",
    categoryText: "text-emerald-600",
    title: "Full-Stack App Development Bootcamp",
    tagline: "Build production-ready web & mobile apps",
    duration: "12 Weeks",
    level: "Intermediate",
    price: 899,
    originalPrice: 1199,
    students: 723,
    rating: 4.9,
    reviews: 189,
    nextStart: "June 2, 2026",
    format: "Live Online",
    image: "https://readdy.ai/api/search-image?query=full%20stack%20web%20development%20coding%20multiple%20screens%20modern%20workspace%20React%20Node%20professional%20clean%20minimal%20light%20background%20tech%20wide&width=800&height=480&seq=ac6&orientation=landscape",
    description: "An intensive bootcamp covering React, Node.js, TypeScript, REST APIs, databases, and mobile development with React Native. Build 3 production-ready apps for your portfolio.",
    outcomes: [
      "Build full-stack web apps with React & Node.js",
      "Design and consume REST APIs and GraphQL",
      "Develop cross-platform mobile apps with React Native",
      "Work with SQL and NoSQL databases",
      "Deploy apps to AWS and Vercel with CI/CD",
    ],
    curriculum: [
      { week: "Week 1–2", topic: "HTML, CSS, JavaScript & TypeScript Foundations" },
      { week: "Week 3–4", topic: "React & State Management" },
      { week: "Week 5–6", topic: "Node.js, Express & REST APIs" },
      { week: "Week 7–8", topic: "Databases: PostgreSQL & MongoDB" },
      { week: "Week 9–10", topic: "React Native & Mobile Development" },
      { week: "Week 11–12", topic: "Deployment, DevOps & Capstone Project" },
    ],
    instructor: { name: "Marcus Webb", role: "Lead App Developer, 10+ yrs exp", avatar: "MW", color: "from-emerald-400 to-teal-500" },
    includes: ["24 live sessions", "Recorded replays", "3 portfolio projects", "Industry certificate", "Slack community", "Job placement support"],
  },
];

export const academyStats = [
  { value: "6,000+", label: "Students Enrolled" },
  { value: "4.9", label: "Average Rating" },
  { value: "94%", label: "Completion Rate" },
  { value: "87%", label: "Got Promoted/Hired" },
];

export const academyTestimonials = [
  {
    id: 1,
    name: "Tunde Bakare",
    role: "AI Engineer at Google",
    avatar: "TB",
    color: "from-violet-400 to-indigo-500",
    course: "AI & Machine Learning Fundamentals",
    text: "CPI Academy's AI course was the turning point in my career. The live sessions were incredibly practical and the instructors answered every question. I landed a role at Google 2 months after graduating.",
  },
  {
    id: 2,
    name: "Rachel Kim",
    role: "Security Analyst at Deloitte",
    avatar: "RK",
    color: "from-rose-400 to-pink-500",
    course: "Advanced Cybersecurity Bootcamp",
    text: "The cybersecurity bootcamp was intense but worth every penny. The CTF challenges were real-world scenarios and the instructors had actual industry experience. Got my first security role within 6 weeks.",
  },
  {
    id: 3,
    name: "Carlos Mendez",
    role: "Cloud Architect at AWS",
    avatar: "CM",
    color: "from-sky-400 to-cyan-500",
    course: "Cloud Architecture Masterclass",
    text: "Passed my AWS Solutions Architect exam on the first try after this course. The sandbox access and hands-on labs made all the difference. Best investment I&apos;ve made in my career.",
  },
];
